import { Component, ContentChild, Input, OnDestroy, OnInit, Optional, TemplateRef } from '@angular/core';
import { DialogSize } from '@models/dialog-size';
import { TranslateService } from '@ngx-translate/core';
import { AnalyticsEventType } from '@services/analytics-events.service';
import { MenuItem } from 'primeng/api';
import { ActionsMenuComponent } from '../actions-menu/actions-menu.component';
import { BatchActionsComponent } from '../batch-actions/batch-actions.component';

@Component({
  selector: 'vnm-dialog-toggle',
  templateUrl: './dialog-toggle.component.html',
  styleUrls: ['./dialog-toggle.component.scss']
})
export class DialogToggleComponent implements OnInit, OnDestroy {
  @Input() label: string;
  @Input() icon: string;
  @Input() disabled = false;

  @Input() header: string;
  @Input() showHeader = true;
  @Input() styleClass = DialogSize.Medium;
  @Input() buttonClass = '';
  @Input() buttonNgClass = {};
  @Input() resizable = false;
  @Input() draggable = false;
  @Input() maximizable = false;
  @Input() modal = true;
  @Input() blockScroll = true;
  @Input() closeIcon = 'fa fa-times';
  @Input() closable = true;
  @Input() iconPos = 'left';
  @Input() visible = false;
  @Input() eventType: AnalyticsEventType;

  @ContentChild(TemplateRef) toggle: TemplateRef<any>;

  private _item: MenuItem;

  constructor(
    @Optional() private actionsMenu: ActionsMenuComponent,
    @Optional() private batchActionsMenu: BatchActionsComponent,
    private translateService: TranslateService
  ) {}

  private get menu() {
    return this.actionsMenu || this.batchActionsMenu;
  }

  ngOnInit() {
    if (this.menu) {
      this._item = {
        label: this.translateService.instant(this.label),
        disabled: this.disabled,
        icon: this.icon,
        command: ({ originalEvent }: { originalEvent: Event }) => this.open(originalEvent)
      };
      this.menu.addItem(this._item);
    }
  }

  ngOnDestroy() {
    this.menu?.removeItem(this._item);
  }

  open(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    this.visible = true;
  }

  close() {
    this.visible = false;
  }
}
